<template>
  <div class="rounded p-2">
    <div class="rounded p-3">
      <div class="row">
        <div v-if="isHealthReferral" class="col-12 col-md-3 pt-4">
          <span class="data-title d-block">Región Parte C:</span>
          <span class="font-16 color-black">
            {{ model.region | empty }}
          </span>
        </div>
        <div v-if="!isHealthReferral" class="col-12 col-md-3 pt-4">
          <span class="data-title d-block">CSEE:</span>
          <span class="font-16 color-black">
            {{ getCsee | empty }}
          </span>
        </div>
        <div class="col-12 col-md-3 pt-4">
          <div class="regular text-gray">
            Fecha de Creación:
          </div>
          {{ formatter(model.creationDate) | empty }}
        </div>

        <div v-if="isHealthReferral" class="col-12 col-md-3 pt-4">
          <div class="regular text-gray">
            Creado por:
          </div>
          {{ model.createdBy | empty }}
        </div>

        <div class="col-12 col-md-3 pt-4">
          <div class="regular text-gray">
            Fecha de Modificación:
          </div>
          {{ formatter(model.modifiedDate) | empty }}
        </div>
        <div class="col-12 col-md-3 pt-4">
          <div class="regular text-gray">
            Modificado por:
          </div>
          {{ model.modifiedBy | empty }}
        </div>
        <div class="col-12 col-md-3 pt-4">
          <div class="regular text-gray">{{ submittedDateLabel }}:</div>
          {{ formatter(model.submittedDate) | empty }}
        </div>
        <div class="col-12 col-md-3 pt-4">
          <div class="regular text-gray">
            Fecha de Completado:
          </div>
          {{ formatter(model.completedDate) | empty }}
        </div>
        <div class="col-12 col-md-3 pt-4">
          <div class="regular text-gray">
            Número de SIE:
          </div>
          {{ model.studentSieId | empty }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { publicPortalRequestTypes } from "@/utils/constants/student/publicPortalRequestTypes.js";
import { capitalize } from "@/utils/filters";

export default {
  name: "AdditionalInformation",
  props: {
    existingData: {
      type: Object,
      default: null
    }
  },
  computed: {
    model() {
      return this.existingData;
    },
    isHealthReferral() {
      if (!this.model) return false;
      return (
        this.model.requestTypeId == publicPortalRequestTypes.HealthReferral
      );
    },
    getCsee() {
      if (!this.model.csee) return "";
      return capitalize(this.model.csee);
    },
    submittedDateLabel() {
      return "Fecha de Sometido";
    }
  },
  methods: {
    formatter(date) {
      return (
        date &&
        moment(date)
          .locale("es")
          .format("DD/MMM/YYYY hh:mm a")
      );
    }
  }
};
</script>
